import { memo } from 'react';

export default memo(() => (
  <div className='layout-right-footer'>

  </div>
));
